import { useCompany } from '../../hooks/useCompany'

function getCompanyLogoUrl(logoValue: string | undefined): string | null {
  if (!logoValue) return null
  if (logoValue.startsWith('http')) return logoValue
  if (logoValue.startsWith('logo')) return `/assets/${logoValue}`
  return null
}

const Footer = () => {
  const { settings } = useCompany()
  const companyLogoUrl = getCompanyLogoUrl(settings?.theme_config?.logo)

  const handleConfigClick = () => {
    window.dispatchEvent(new CustomEvent('openConfigModal'))
  }

  return (
    <footer className="bg-black text-white py-12 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <div className="mb-2 flex flex-wrap items-center justify-center md:justify-start gap-3">
              {companyLogoUrl && (
                <div className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 shadow-sm">
                  <img
                    src={companyLogoUrl}
                    alt="Company"
                    className="h-10 w-auto max-h-10 object-contain"
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = 'none'
                    }}
                  />
                </div>
              )}
            </div>
            <p className="text-gray-400 text-sm">Simplifying the complex. Automating the simple.</p>
          </div>

          <div className="flex space-x-6 mb-6 md:mb-0">
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <i className="fa-brands fa-linkedin text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <i className="fa-brands fa-twitter text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <i className="fa-solid fa-envelope text-xl"></i>
            </a>
            <button
              onClick={handleConfigClick}
              className="text-gray-600 hover:text-white transition-colors"
              title="Setup Supabase"
            >
              <i className="fa-solid fa-key"></i>
            </button>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>© 2026 Simple Insights Private Limited. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
